class CF7 {
  constructor() {
    this.url = `${scriptsData.restUrl}wp/v2/cf7`;
    this.onMailSent = this.onMailSent.bind(this);
    document.addEventListener('wpcf7mailsent', this.onMailSent, false);
  }

  onMailSent(event) {


    if (!event || !event.detail || !event.detail.inputs) {
      console.error('Invalid event object or missing form data.');
      return;
    }

    const formData = this.parseFormData(event.detail.inputs);

    fetch(`${this.url}/send`, {
      method: 'POST',
      headers: {
        'X-WP-Nonce': scriptsData.nonce,
      },
      body: formData,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json(); // or response.text(), etc.
      })
      .then(data => {
        console.log(data);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }

  parseFormData(inputs) {
    const formData = new FormData();
    for (const [key, entry] of Object.entries(inputs)) {
      formData.append(entry.name, entry.value);
    }
    return formData;
  }

}

new CF7();